import { MARQUEE_ITEMS } from "@/data/siteData";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative border-y border-teal-500/15 bg-[#111A33] py-5 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-lg sm:text-xl tracking-[0.2em] text-slate-400 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-teal-400 text-xs">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
